import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import type { IExamProgressStatus } from "./types";

export async function apiGetExamPaperStatus(
  progressId: string,
  examPaperId: string
) {
  return apiGet<IExamProgressStatus>(
    `/exam_progress/${progressId}/exam_papers/${examPaperId}/status`
  );
}

export function useQueryGetExamPaperStatus(
  progressId: string,
  examPaperId: string,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: ["examPaperStatus", progressId, examPaperId],
    queryFn: () => apiGetExamPaperStatus(progressId, examPaperId),
    select: (data) => data.data,
    enabled: !!progressId && !!examPaperId && options?.enabled !== false,
  });
}
